import React from "react";

export const FontRobotoSlab = (props: React.PropsWithChildren<{}>): JSX.Element => (
    <span
        style={{
            fontFamily: "Roboto Slab, sans-serif",
            display: "inline-flex",
        }}
    >
        {props.children}
    </span>
);
